import { EDIT_ALERT, FETCH_ALERTS } from './AlertsActions'

const INITIAL_STATE = {
  items: [],
  meta: {},
  filters: {},
  editingAlert: null,
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_ALERTS.SUCCESS:
      return {
        ...state,
        items: action.payload.data.data,
        meta: action.payload.data.meta,
        filters: action.payload.filters,
      }
    case EDIT_ALERT.ACTION:
      return {
        ...state,
        editingAlert: null,
      }
    case EDIT_ALERT.SUCCESS:
      return {
        ...state,
        editingAlert: action.payload,
      }
    default:
      return state
  }
}
